import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";

// ANT DESIGN ICONS IMPORTS
import {
  LeftOutlined,
  SearchOutlined,
  ReloadOutlined,
} from "@ant-design/icons";

// ANT DESIGN IMPORTS
import {
  Input,
  Button,
  Form,
  DatePicker,
  Row,
  Col,
  Typography,
  Modal,
  Divider,
  Card,
  Table,
  Spin,
  Select,
  Statistic,
  InputNumber,
} from "antd";

// PROJECT IMPORTS
import MainLayout from "../../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../../components/layouts/TopContent";
import appStatic from "../../../../../../../config/appStatic";
import { BOM } from "../../../../../../../services/definedMethod";
import cnt from "../../../../../../../services/definedConstant";
import { rightAction } from "../../../../../../../redux/actions";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../../group.config";
import styles from "../../../../../../../assets/styles/styles";
import DownloadTableButtons from "../../../../../../../components/DownloadTableButtons";

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {},
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: "Entry ID",
    dataIndex: "id",
  },
  {
    title: "Office",
    dataIndex: "office",
    sorter: (a, b) => a.branch.localeCompare(b.branch),
  },
  {
    title: "Transaction Date",
    dataIndex: "transactionDate",
    sorter: (a, b) => a.transactionDate.localeCompare(b.transactionDate),
  },
  {
    title: "Transaction ID",
    dataIndex: "transactionId",
  },
  {
    title: "Type",
    dataIndex: "type",
    sorter: (a, b) => a.account.localeCompare(b.account),
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
  },
  {
    title: "Account",
    dataIndex: "account",
  },
  {
    title: "Debit",
    dataIndex: "debit",
  },
  {
    title: "Credit",
    dataIndex: "credit",
  },
];

const GroupSavingsJournalEntries = (props) => {
  const { userData, rightBtn } = props;
  const { monthList } = appStatic;
  const { session } = userData;
  const { RangePicker } = DatePicker;
  const { Text } = Typography;
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [journalEntryList, setJournalEntryList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [open, setOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [accountData, setAccountData] = useState([]);
  const [officeData, setOfficeData] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    // console.log(state);

    getJournalEntryListAction();
    dispatch({
      type: cnt.CLEAR_RIGHT_BTN,
    });

    getOffice();
    getGlAccount();
  }, []);

  //DECLARED METHODS
  function getOffice() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Offices, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(temp);
      }
    });
  }
  const getJournalEntryListAction = () => {
    const params = {
      dateFormat: "dd MMMM yyyy",
      limit: 200,
      locale: "en",
      offset: 0,
      savingsId: state.id,
    };

    const url = `${apiConfig.JournalEntries}`;

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            branch: element?.officeName ? element?.officeName : "-",
            transactionDate: element?.transactionDate
              ? `${element?.transactionDate[2]} ${
                  monthList[element?.transactionDate[1] - 1]
                } ${element?.transactionDate[0]}`
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            debit:
              element?.entryType?.value?.toLowerCase() === "debit"
                ? ` ${element?.amount}`
                : "-",
            credit:
              element?.entryType?.value?.toLowerCase() === "credit"
                ? ` ${element?.amount}`
                : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                ? "Cr"
                : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setJournalEntryList(tempArray.filter((item) => item.disabled === false));
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  function getGlAccount() {
    const url = `${apiConfig.GlAccounts}`;
    const params = {
      disabled: false,
      usage: 1,
    };
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: `${element.name} ${element.glCode}`,
          });
        });

        setAccountData(temp);
      }
    });
  }

  // FLOAT METHODS
  function handleOnView() {
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-group-savings-journal-entry", {
        state: { ...state, transactionId: selectedRow.transactionId },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }
  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-ManageJournalEntry", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  function handleOnSearch() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/search-CurrentAccJournalEntry", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [cnt.RIGHT_DETAIL_BTN].map((item) => {
      dispatch({
        type: item,
      });
    });
  };
  const onRefresh = () => {
    form.resetFields();
    getJournalEntryListAction();
  };
  function onCancel() {
    navigate("/detail-group-savings", { state: state });
  }
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    const url = `${apiConfig.JournalEntries}`;
    const params = {
      dateFormat: "dd MMMM yyyy",
      limit: 14,
      locale: "en",
      offset: 0,
      // savingsId:2210,
      // transactionUniqueId:65083,
    };
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let temp = [];

        objList.forEach((element) => {
          temp.push({
            value: element.id,
            label: `${element.name} ${element.glCode}`,
          });
        });

        setAccountData(temp);
      }
    });
    setOpen(false);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  const onSubmit = (formValues) => {
    formValues.fromDate = BOM.DateTime(formValues.date[0], "only-date");

    formValues.toDate = BOM.DateTime(formValues.date[1], "only-date");

    const params = {
      dateFormat: "dd+MMMM+yyyy",
      glAccountId: formValues.glAccountId,
      officeId: formValues.officeId,
      offset: 0,
      limit: 14,
      locale: "en",
      fromDate: encodeURIComponent(formValues.fromDate).replace(/%20/g, "+"),
      toDate: encodeURIComponent(formValues.toDate).replace(/%20/g, "+"),
      manualEntriesOnly: "",
    };

    const url = `${apiConfig.JournalEntries}?`;
    const body = {
      ...formValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",
      session,
      params,
    };

    setIsLoading(true);
    setShowSearch(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id ? element?.id : "-",
            office: element?.officeName ? element?.officeName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
            transactionDate: element?.transactionDate
              ? `${element?.transactionDate[2]} ${
                  monthList[element?.transactionDate[1] - 1]
                } ${element?.transactionDate[0]}`
              : "-",
            transactionId: element?.transactionId
              ? element?.transactionId
              : "-",
            type: element?.glAccountType?.value
              ? element?.glAccountType?.value
              : "-",
            createdBy: element?.createdByUserName
              ? element?.createdByUserName
              : "-",
            account: element?.glAccountName
              ? `${element?.glAccountName} (${element?.glAccountCode})`
              : "-",
            debit:
              element?.entryType?.value?.toLowerCase() === "debit"
                ? element?.amount
                : "-",
            credit:
              element?.entryType?.value?.toLowerCase() === "credit"
                ? element?.amount
                : "-",
            transactionTag: element?.entryType?.value
              ? element?.entryType?.value === "DEBIT"
                ? "Dr"
                : element?.entryType?.value === "CREDIT"
                ? "Cr"
                : "-"
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              "-"
            ),
            amountToUse: element?.amount ? element?.amount : 0,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setJournalEntryList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
        useForm.resetFields();
      }
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onSearch={handleOnSearch}
    >
      <TopContent
        pageTitle={labelConfig.journalEntries}
        pageItems={staticConfig.journalEntriesSavingsGrpBreadcrumbItems}
      />

      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
        title={
          <Row
            style={{
              alignContent: "center",
              width: "8%",
            }}
          >
            <Button
              icon={<LeftOutlined />}
              type="text"
              style={{
                marginTop: "auto",
                marginBottom: "auto",
              }}
              onClick={onCancel}
            >
              <Text
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                  fontSize: 15,
                }}
              >
                Back
              </Text>
            </Button>
          </Row>
        }
      >
        <Row>
          <Button
            type="primary"
            className="of-primaryBtnColor"
            shape="round"
            onClick={showModal}
          >
            <SearchOutlined />
            &nbsp;{labelConfig.searchParams}
          </Button>
          <Button
            type="primary"
            shape="round"
            className="of-primaryBtnColor"
            onClick={onRefresh}
            icon={<ReloadOutlined />}
            loading={isLoading}
            style={{
              marginLeft: 10,
              marginBottom: "auto",
            }}
          >
            {labelConfig.refresh}
          </Button>
          {/* <DownloadTableButtons
            downloadData={journalEntryList}
            columns={columns}
            fileName="Journal Entries List"
          /> */}
        </Row>

        <Modal
          title="Search Journal Entries"
          open={open}
          okText="Search"
          cancelText="Cancel"
          okButtonProps={{
            autoFocus: true,
            htmlType: "submit",
            style: {
              ...styles.ofPrimaryBtnColor,
            },
          }}
          centered
          onCancel={handleCancel}
          onOk={handleOk}
          width={1000}
          modalRender={(dom) => (
            <Form layout="vertical" form={form} onFinish={onSubmit}>
              {dom}
            </Form>
          )}
          style={{
            height: 600,
            overflow: "auto",
          }}
        >
          <Spin spinning={isLoading} tip="Loading..." size="large">
            {/* <Text>RENDER TABLE LIST HERE</Text> */}
            <Row style={{ justifyContent: "space-betwen" }}>
              <Divider orientation="left" orientationMargin="0">
                {/* <Text level={3} style={{ margin: 0, marginBottom: 0 }}> */}
                {labelConfig.generalInfo}
                {/* </Text> */}
              </Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="officeId"
                  label={<Text>{labelConfig.branch}</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    options={officeData}
                    showSearch
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.branch)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="glAccountId"
                  label={<Text>{labelConfig.account}</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    options={accountData}
                    showSearch
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.account)}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="date"
                  label={<Text>{labelConfig.dateRange}</Text>}
                >
                  <RangePicker style={{ width: "100%", height: 35 }} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="manualEntriesOnly"
                  label={<Text>{labelConfig.filter}</Text>}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.filter,
                      "select"
                    )}
                    options={staticConfig.filterByEntries}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  name="transactionId"
                  label={<Text>{labelConfig.transactionId}</Text>}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.transactionId
                    )}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Spin>
        </Modal>
        <Divider orientation="left" />

        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={journalEntryList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupSavingsJournalEntries);
